<template>
  <div class="block search-block">
    <el-form
      :inline="true"
      class="demo-form-inline custom-form"
      ref="queryForm"
    >
      <template v-for="(query,index) in queryParams">
        <el-form-item
          :key="index"
          :label="query.label+':'"
        >
          <template v-if="query.type==='select'">
            <el-select @change="query.linkage?linkageHandle(query.linkage):''" v-model="queryVal[query.code]">
              <el-option
                :label="option.name"
                :value="option.value"
                v-for="(option,index) in query.options"
                :key="index"
              ></el-option>
            </el-select>
          </template>

          <template v-else-if="query.type==='numberBetween'">
            <el-form-item class="number">
              <el-input v-model="queryVal[query.code.split(',')[0]]"></el-input>
            </el-form-item>~
            <el-form-item class="number">
              <el-input v-model="queryVal[query.code.split(',')[1]]"></el-input>
            </el-form-item>
          </template>

          <template v-else-if="query.type==='dateBetween'">
            <el-form-item>
              <el-date-picker
                class="date"
                type="date"
                v-model="queryVal[query.code.split(',')[0]]"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>~
            <el-form-item>
              <el-date-picker
                class="date"
                type="date"
                v-model="queryVal[query.code.split(',')[1]]"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </template>

          <template v-else>
            <el-input v-model="queryVal[query.code]"></el-input>
          </template>
        </el-form-item>
      </template>
      <el-form-item>
        <el-button
          type="primary"
          @click="doSearch"
        >查询</el-button>
      </el-form-item>
      <slot name="btns"></slot>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    queryParams: Array,
    //是否初始化之后立即执行(要赋值查询条件的传入false，等查询条件赋值完后执行)
    immedQuery: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      queryVal: {}
    }
  },
  created() {
    if (this.immedQuery) this.init()
  },
  methods: {
    init() {
      this.queryParams.forEach(param => {
        var keys = param.code ? param.code.split(',') : []
        var vals = param.defaultValue ? param.defaultValue.split(',') : []
        keys.forEach((key, index) => {
          var val = vals[index] ? vals[index] : ''
          this.$set(this.queryVal, key, val)
        })
      })
      this.doSearch()
    },
    doSearch() {
      this.$emit("doSearch", this.queryVal);
    },
    linkageHandle(eventHandle){
      this.$emit('change',{handle:eventHandle,query:this.queryVal})
    }
  },
  watch: {
    queryParams(val) {
      this.init()
    }
  }
}
</script>


<style lang="scss" scope>
.number {
  width: 50px;
}
.date {
  width: 150px !important;
}
/*修改表单组件样式start*/
.search-block {
  padding: 10px 30px;
}
.custom-form {
  .el-input__inner {
    height: 30px;
    line-height: 30px;
  }
  .el-button {
    padding: 7px 20px !important;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}

/*修改表单组件样式end*/
</style>
